import React, { useState, useEffect, useMemo } from 'react';
import { useAuth } from '../context/AuthContext';
import { DashboardView } from './ownerSpace/DashboardView';
import { PaymentsView } from './ownerSpace/PaymentsView';
import { MeetingsView } from './ownerSpace/MeetingsView';
import { TicketsView } from './ownerSpace/TicketsView';

export default function OwnerSpaceModule() {
  const { user } = useAuth();
  const userRole = (user?.role ?? user?.rol ?? '').toString();
  const isContador = userRole.toLowerCase() === 'contador';
  
  const companies = ["TODAS (Vista General)", "GENERAL TIRE", "MIGUEL", "MAURICIO", "IMPORTADORA"];
  const allTabs = ["Dashboard", "Pagos", "Reuniones", "Pendientes"];
  
  const visibleTabs = useMemo(() => {
    if (isContador) {
      return ["Pagos"];
    }
    return allTabs;
  }, [userRole]);

  const [activeCompany, setActiveCompany] = useState(companies[0]);
  const [activeTab, setActiveTab] = useState(visibleTabs[0]);

  useEffect(() => {
    if (!visibleTabs.includes(activeTab)) {
      setActiveTab(visibleTabs[0]);
    }
  }, [visibleTabs, activeTab]);

  const companyForAPI = activeCompany === "TODAS (Vista General)" ? "TODAS" : activeCompany;

  return (
    <div className="space-y-6">
      <div className="rounded-3xl bg-gradient-to-r from-slate-900 via-slate-800 to-slate-700 px-6 py-8 shadow-xl">
        <h2 className="text-2xl md:text-3xl font-semibold text-white">Espacio Personal</h2>
        <p className="text-slate-300 mt-1">
          {isContador
            ? 'Consulta y exporta los pagos realizados.'
            : 'Pagos, reuniones y pendientes en un solo lugar — con estilo.'
          }
        </p>

        <div className="mt-5 flex flex-col lg:flex-row lg:items-center gap-3">
          <div className="flex items-center gap-2 bg-white/10 rounded-2xl p-2 ring-1 ring-white/10 backdrop-blur">
            <label className="sr-only">Empresa</label>
            <select
              value={activeCompany}
              onChange={(e)=>setActiveCompany(e.target.value)}
              className="rounded-xl bg-white text-slate-800 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-white/20"
            >
              {companies.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
            <span className="text-white/70 text-xs px-2">Selecciona empresa (solo afecta Pagos)</span>
          </div>

          {visibleTabs.length > 1 && (
            <div className="flex items-center gap-2 bg-white/10 rounded-2xl p-2 ring-1 ring-white/10 backdrop-blur">
              {visibleTabs.map(tab => {
                const active = tab === activeTab;
                return (
                  <button key={tab} onClick={()=>setActiveTab(tab)}
                          className={`relative rounded-xl px-3 py-1.5 text-sm font-medium transition
                            ${active ? 'text-slate-900 bg-white shadow' : 'text-white/80 hover:text-white hover:bg-white/10'}`}>
                    {tab}
                  </button>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {activeTab === "Dashboard" && <DashboardView />}
      {activeTab === "Pagos" && <PaymentsView company={companyForAPI} userRole={userRole} />}
      {activeTab === "Reuniones" && <MeetingsView />}
      {activeTab === "Pendientes" && <TicketsView />}
    </div>
  );
}